<template>
  <div>
    <div
      v-if="!printOnly"
      class="preview-toolbar"
      style="
        font-family: Arial, Helvetica, sans-serif !important;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <div style="font-size: 30px; text-align: center; margin-bottom: 15px">
        Vista Previa de Impresión de Ticket ({{ invoiceTitlePreview }})
      </div>
      <div style="text-align: center">
        <button style="font-size: 18px" @click="Print()">Imprimir</button>
        &nbsp;&nbsp;
        <button style="font-size: 18px" @click="Download()">Descargar</button>
        &nbsp;&nbsp;
        <button
          v-if="!hideQr"
          style="font-size: 18px"
          @click="sendMail()"
        >
          Enviar Correo
        </button>
        &nbsp;&nbsp;
        <button
          v-if="!hideQr"
          style="font-size: 18px"
          @click="downLoadJSON()"
        >
          Descargar JSON
        </button>
        <download-invalidation-json :header="dataProps.data.header" />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button
          v-if="!hideQr"
          style="font-size: 18px"
          @click="$emit('input', 'regular')"
        >
          Ver en formato normal
        </button>
      </div>
      <div v-if="loading" style="text-align: center">Cargando...</div>
    </div>

    <div
      v-if="!printOnly"
      class="preview-toolbar"
      style="
        font-family: Arial, Helvetica, sans-serif !important;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <div v-if="mailLabel">{{ mailLabel }}</div>
    </div>

    <div
      class="book"
      :style="{
        margin: '0',
        padding: printOnly ? '0' : '20px 0',
        backgroundColor: printOnly ? 'white' : 'rgb(105, 105, 105)',
        fontFamily: 'Arial, Helvetica, sans-serif',
      }"
    >
      <div
        class="book-frame"
        :style="{
          margin: printOnly ? '0' : '0 auto',
          width: printOnly ? '325px' : '400px',
          display: 'flex',
          justifyContent: 'center',
          fontSize: '10pt',
        }"
      >
        <div
          ref="dataprint"
          class="ticket-shell"
          style="
            margin: 0 !important;
            padding: 0 !important;
            font-family: Arial, Helvetica, sans-serif !important;
          "
        >
          <div
            class="ticket"
            :style="{
              width: '325px',
              maxWidth: '325px',
              background: 'white',
              padding: '18px 22px 32px',
              boxSizing: 'border-box',
              color: '#111',
              fontSize: ticketPt(7.5),
              lineHeight: ticketLineHeight(1.22),
            }"
          >
            <div
              v-if="dataProps.data.header.FeMhEstado == 'RECHAZADO'"
              style="width: 100%; background-color: red; margin-bottom: 8px"
            >
              <h3 style="color: white; text-align: center; margin: 0; padding: 6px 4px">
                DOCUMENTO RECHAZADO POR HACIENDA
              </h3>
            </div>
            <div
              v-if="dataProps.data.header.FeMhEstado == 'INVALIDADO'"
              style="width: 100%; background-color: red; margin-bottom: 8px"
            >
              <h3 style="color: white; text-align: center; margin: 0; padding: 6px 4px">
                DOCUMENTO INVALIDADO POR HACIENDA
              </h3>
            </div>

            <div v-if="!hideQr && urlQr" style="text-align: center; margin: 0 0 8px">
              <img
                ref="qrcode"
                :src="urlQr"
                style="width: 108px; height: 108px"
                crossorigin="anonymous"
              />
            </div>

            <div
              v-if="showLogo && false"
              style="text-align: center; margin-bottom: 6px"
            >
              <img
                :src="dataProps.data.branch.BranchLogoPath"
                crossorigin="anonymous"
                style="max-width: 120px; max-height: 42px; width: auto; height: auto; object-fit: contain"
              />
            </div>

            <table
              :style="{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: ticketPt(6.9),
                textAlign: 'center',
                lineHeight: ticketLineHeight(1.12),
              }"
            >
              <tr>
                <td :style="{ fontSize: ticketPt(8.3), fontWeight: 'bold', overflowWrap: 'anywhere', wordBreak: 'break-word' }">
                  {{ displayText(dataProps.data.user.business, true) }}
                </td>
              </tr>
              <tr v-if="branchAddress">
                <td>{{ branchAddress }}</td>
              </tr>
              <tr v-if="branchPhone">
                <td>TEL: {{ branchPhone }}</td>
              </tr>
              <tr v-if="branchActivity">
                <td :style="{ overflowWrap: 'anywhere', wordBreak: 'break-word' }">GIRO: {{ branchActivity }}</td>
              </tr>
              <tr v-if="BillingNit">
                <td>NIT: {{ BillingNit }}</td>
              </tr>
              <tr v-if="BillingNrc">
                <td>NRC: {{ BillingNrc }}</td>
              </tr>
              <tr>
                <td :style="{ paddingTop: '8px', fontSize: ticketPt(9.4), fontWeight: 'bold' }">
                  {{ invoiceTitle }}
                </td>
              </tr>
              <tr>
                <td :style="{ paddingTop: '2px', fontSize: ticketPt(8), fontWeight: 'bold', overflowWrap: 'anywhere', wordBreak: 'break-word' }">
                  No. {{ invoiceCorrelative }}
                </td>
              </tr>
            </table>

            <table
              :style="{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: ticketPt(7),
                marginTop: '8px',
              }"
            >
              <tr>
                <td style="text-align: center">
                  Fecha: {{ dataProps.data.header.InvoiceDate }} {{ dataProps.data.header.IdentificacionHorEmi }}
                </td>
              </tr>
            </table>

            <table
              :style="{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: ticketPt(6.8),
                lineHeight: ticketLineHeight(1.12),
                marginTop: '8px',
              }"
            >
              <tr>
                <td :style="{ overflowWrap: 'anywhere', wordBreak: 'break-word' }"><strong>COD. GENERACION:</strong> {{ dataProps.data.header.CodigoGeneracion }}</td>
              </tr>
              <tr>
                <td :style="{ overflowWrap: 'anywhere', wordBreak: 'break-word' }"><strong>SELLO RECEPCION:</strong> {{ dataProps.data.header.SelloRecepcion }}</td>
              </tr>
              <tr>
                <td :style="{ overflowWrap: 'anywhere', wordBreak: 'break-word' }"><strong>NUM. CONTROL:</strong> {{ dataProps.data.header.NumeroControl }}</td>
              </tr>
            </table>

            <hr style="margin: 8px 0" />

            <table
              :style="{
                width: '100%',
                borderCollapse: 'collapse',
                tableLayout: 'fixed',
                fontSize: ticketPt(6.9),
              }"
            >
              <thead>
                <tr>
                  <th style="width: 14%; text-align: left; padding-bottom: 4px; padding-right: 4px">CANT.</th>
                  <th style="width: 42%; text-align: center; padding-bottom: 4px; padding-left: 2px">PRODUCTO</th>
                  <th style="width: 20%; text-align: right; padding-bottom: 4px; padding-right: 8px">UNIT.</th>
                  <th style="width: 24%; text-align: right; padding-bottom: 4px">TOTAL</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in invoiceItems" :key="index">
                <tr>
                  <td
                    colspan="4"
                    :style="{
                      verticalAlign: 'top',
                      padding: '3px 0 1px 0',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }"
                  >
                    <div
                      :style="{
                        display: 'block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                      }"
                    >
                      {{ displayText(item.ItemDescription, true) }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 0 4px 6px 0; vertical-align: top">
                    {{ item.ItemQuantity }}
                  </td>
                  <td style="padding: 0"></td>
                  <td style="padding: 0 8px 6px 0; text-align: right; white-space: nowrap">
                    {{ money(item.ItemUnitPrice) }}
                  </td>
                  <td style="padding: 0 0 6px; text-align: right; white-space: nowrap">
                    {{ money(itemSubtotal(item)) }}{{ itemTaxFlag(item) ? ` ${itemTaxFlag(item)}` : "" }}
                  </td>
                </tr>
              </tbody>
            </table>

            <hr style="margin: 10px 0 6px" />

            <table
              :style="{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: ticketPt(7),
              }"
            >
              <tr v-if="parseNumber(dataProps.data.header.InvoiceTotalGravada) > 0">
                <td style="width: 80%">VENTA GRAVADA</td>
                <td style="width: 20%; text-align: right">{{ money(dataProps.data.header.InvoiceTotalGravada) }}</td>
              </tr>
              <tr v-if="parseNumber(dataProps.data.header.InvoiceTotalExenta) > 0">
                <td>VENTA EXENTA</td>
                <td style="text-align: right">{{ money(dataProps.data.header.InvoiceTotalExenta) }}</td>
              </tr>
              <tr v-if="parseNumber(dataProps.data.header.InvoiceTotalNoSuj) > 0">
                <td>VENTA NO SUJETA</td>
                <td style="text-align: right">{{ money(dataProps.data.header.InvoiceTotalNoSuj) }}</td>
              </tr>
              <tr v-if="parseNumber(invoiceSubTotalVentas) > 0">
                <td>SUB TOTAL DE VENTAS</td>
                <td style="text-align: right">{{ money(invoiceSubTotalVentas) }}</td>
              </tr>
              <tr v-if="parseNumber(dataProps.data.header.InvoiceTotalDescu) > 0">
                <td>TOTAL DESCUENTOS</td>
                <td style="text-align: right">{{ money(dataProps.data.header.InvoiceTotalDescu) }}</td>
              </tr>
              <tr v-if="dataProps.data.header.InvoiceType == 'CCF' && parseNumber(dataProps.data.header.InvoiceTotalIva) > 0">
                <td>IVA</td>
                <td style="text-align: right">{{ money(dataProps.data.header.InvoiceTotalIva) }}</td>
              </tr>
              <tr v-if="dataProps.data.header.InvoiceType == 'CCF' && parseNumber(dataProps.data.header.InvoiceSubTotal) > 0">
                <td>SUB TOTAL</td>
                <td style="text-align: right">{{ money(dataProps.data.header.InvoiceSubTotal) }}</td>
              </tr>
              <tr v-if="parseNumber(dataProps.data.header.InvoiceIvaRete1) > 0">
                <td>IVA RETENIDO</td>
                <td style="text-align: right">{{ money(dataProps.data.header.InvoiceIvaRete1) }}</td>
              </tr>
              <tr v-if="parseNumber(dataProps.data.header.InvoiceIvaPerce1) > 0">
                <td>IVA PERCIBIDO</td>
                <td style="text-align: right">{{ money(dataProps.data.header.InvoiceIvaPerce1) }}</td>
              </tr>
              <tr v-if="parseNumber(invoiceRentRetention) > 0">
                <td>IMPUESTO SOBRE LA RENTA</td>
                <td style="text-align: right">{{ money(invoiceRentRetention) }}</td>
              </tr>
              <tr v-if="parseNumber(dataProps.data.header.InvoiceTotalNoGravado) > 0">
                <td>TOTAL OTROS MONTOS NO AFECTOS</td>
                <td style="text-align: right">{{ money(dataProps.data.header.InvoiceTotalNoGravado) }}</td>
              </tr>
              <tr v-if="parseNumber(cash) > 0">
                <td>EFECTIVO</td>
                <td style="text-align: right">{{ money(cash) }}</td>
              </tr>
              <tr>
                <td>CAMBIO</td>
                <td style="text-align: right">{{ money(change) }}</td>
              </tr>
            </table>

            <table
              :style="{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: ticketPt(11),
                marginTop: '3px',
              }"
            >
              <tr>
                <td
                  style="
                    width: 58%;
                    text-align: right;
                    font-weight: bold;
                    border-top: 1px solid #555;
                    padding-top: 4px;
                  "
                >
                  VENTA TOTAL
                </td>
                <td
                  :style="{
                    width: '42%',
                    textAlign: 'right',
                    fontWeight: 'bold',
                    fontSize: ticketPt(11),
                    borderTop: '1px solid #555',
                    paddingTop: '4px',
                  }"
                >
                  {{ money(dataProps.data.header.InvoiceTotalPagar) }}
                </td>
              </tr>
            </table>

            <div :style="{ marginTop: '6px', fontSize: ticketPt(6.6), textAlign: 'center', fontWeight: 'bold' }">
              (G) = Gravadas &nbsp; (E) = Exentas &nbsp; (N) = No Sujetas
            </div>

            <table
              v-if="clientSummary"
              :style="{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: ticketPt(7),
                marginTop: '8px',
                lineHeight: ticketLineHeight(1.12),
              }"
            >
              <tr v-if="hasValue(dataProps.data.header.InvoiceName)">
                <td><strong>CLIENTE:</strong> {{ displayText(dataProps.data.header.InvoiceName, true) }}</td>
              </tr>
              <tr v-if="hasValue(dataProps.data.header.InvoiceAddress)">
                <td>{{ displayText(dataProps.data.header.InvoiceAddress, true) }}</td>
              </tr>
              <tr v-if="hasValue(dataProps.data.header.InvoiceNIT)">
                <td>No. NIT: {{ dataProps.data.header.InvoiceNIT }}</td>
              </tr>
              <tr v-else-if="hasValue(dataProps.data.header.InvoiceDUI)">
                <td>No. DUI: {{ dataProps.data.header.InvoiceDUI }}</td>
              </tr>
            </table>

            <template v-if="dataProps.data.header.InvoiceInternalNote">
              <hr style="margin: 8px 0" />
              <div :style="{ fontSize: ticketPt(7) }">
                <strong>Observaciones:</strong> {{ commentsOuterHtml }}
              </div>
            </template>

            <template
              v-if="
                dataProps.data.header.ShowResponsabilitiesInInvoice ||
                dataProps.data.header.InvoiceTotalPagar >= 25000
              "
            >
              <hr style="margin: 8px 0" />
              <div :style="{ fontSize: ticketPt(7), lineHeight: ticketLineHeight(1.2) }">
                <div>
                  <strong>Responsable por parte del receptor:</strong>
                  {{ dataProps.data.header.InvoiceExtNombEntrega }}
                </div>
                <div>
                  <strong>No. Documento:</strong>
                  {{ dataProps.data.header.InvoiceExtDocuEntrega }}
                </div>
                <div>
                  <strong>Responsable por parte del emisor:</strong>
                  {{ dataProps.data.header.InvoiceExtNombRecibe }}
                </div>
                <div>
                  <strong>No. Documento:</strong>
                  {{ dataProps.data.header.InvoiceExtDocuRecibe }}
                </div>
              </div>
            </template>

            <div style="margin-top: 8px">
              <GuaranteePrintBlock
                :html="dataProps.guaranteeHtml"
                :business-id="dataProps.businessId"
                :branch-id="dataProps.branchId"
                guarantee-type="TICKET"
                font-size="7pt"
              />
            </div>

            <div class="ticket-divider"></div>
            <div class="ticket-thanks">Gracias por su visita!</div>
            <div
              v-if="['d76ca00b6f45acf9815bc10e1d9b7652'].includes(keyMaster)"
              class="ticket-return-note"
            >
              NO SE ACEPTAN DEVOLUCIONES
            </div>
            <div class="ticket-end-space"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadInvalidationJson from "@/components/ReportsAndPrintings/DownloadInvalidationJson.vue";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc";
import { formatNumber } from "../../helpers/money";
import { numberToText } from "@/helpers/conveterNumberText.js";
import { imprimirFactura } from "../../utils/printInvoice";
import GuaranteePrintBlock from "@/components/ReportsAndPrintings/GuaranteePrintBlock.vue";

export default {
  name: "PrintPosFacturaTicketV2",
  model: {
    event: "input",
    prop: "type",
  },
  props: {
    dataProps: {
      type: Object,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
    printOnly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  components: { DownloadInvalidationJson,
    GuaranteePrintBlock,
  },
  data() {
    return {
      header: null,
      footer: null,
      loading: false,
      numPages: 0,
      mailLabel: null,
      valuesRows: [],
      urlQr: null,
      typePrint: 0,
      keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
      ticketformat3nstar:
        JSON.parse(localStorage.getItem("user")).ticketformat3nstar || 0,
      ticketdirectprinting:
        JSON.parse(localStorage.getItem("user")).ticketdirectprinting || 0,
      useNormalTicketV2FontSize:
        parseFloat(
          (JSON.parse(localStorage.getItem("user")) || {}).usenormalticketv2fontsize
        ) || 7.5,
      cash: 0,
      change: 0,
      ShowCorrelativeControl: JSON.parse(localStorage.getItem("user"))
        .showcorrelativecontrol,
    };
  },
  mounted() {
    this.showData();
    this.calculateTotalValues();
  },
  computed: {
    commentsOuterHtml() {
      return (this.dataProps.data.header.InvoiceInternalNote || "").replace(
        /<[^>]*>/g,
        ""
      );
    },
    BillingNrc() {
      return addFormatNRC(this.dataProps.data.branch.BusinessBillingNRC);
    },
    BillingNit() {
      return addFormatToNIT(this.dataProps.data.branch.BusinessBillingNIT);
    },
    invoiceTitle() {
      if (this.dataProps.data.header.InvoiceType === "CCF") {
        return "COMPROBANTE CREDITO FISCAL";
      }
      return "FACTURA CONSUMIDOR FINAL";
    },
    invoiceTitlePreview() {
      if (this.dataProps.data.header.InvoiceType === "CCF") {
        return "Factura credito fiscal";
      }
      return "Factura consumidor final";
    },
    invoiceItems() {
      return this.dataProps.data.body || [];
    },
    invoiceCorrelative() {
      return this.dataProps.data.header.ID_Invoice || "";
    },
    invoiceInternalCorrelative() {
      const { InvoiceType, Correlative_ID_Invoice } = this.dataProps.data.header;
      return `${InvoiceType || ""}-${Correlative_ID_Invoice || ""}`;
    },
    invoiceModelLabel() {
      const model = this.dataProps.data.dteJson.IdentificacionTipoModelo;
      if (model == 1) return "Previo";
      if (model == 2) return "Diferido";
      return "";
    },
    invoiceTransmissionLabel() {
      const operation = this.dataProps.data.dteJson.IdentificacionTipoOperacion;
      if (operation == 1) return "Normal";
      if (operation == 2) return "Por contingencia";
      return "";
    },
    currencyLabel() {
      const currency = this.dataProps.data.header.InvoiceCurrency;
      return currency === "$" ? "USD" : currency || "";
    },
    branchAddress() {
      return this.displayText(this.dataProps.data.branch.BranchLegalAddress, true);
    },
    branchPhone() {
      return this.displayText(this.dataProps.data.branch.BranchPhone, false);
    },
    branchMobile() {
      return (
        this.dataProps.data.branch.BranchMobile ||
        this.dataProps.data.branch.BranchManagerMobile ||
        this.dataProps.data.branch.BranchContactMobile ||
        ""
      );
    },
    branchActivity() {
      return this.displayText(
        this.dataProps.data.header.EmisorDescActividad,
        true
      );
    },
    showLogo() {
      const logo = this.dataProps.data.branch?.BranchLogoPath;
      return logo && logo !== "null";
    },
    cashierLabel() {
      const branch = this.displayText(this.dataProps.data.branch.BranchName, true);
      const user = this.displayText(this.dataProps.data.header.UserName, true);
      const pieces = [];

      if (branch) {
        pieces.push(`Caja: ${branch}`);
      }
      if (user) {
        pieces.push(`Vendedor: ${user}`);
      }

      return pieces.join(" / ");
    },
    invoiceSubTotalVentas() {
      const header = this.dataProps.data.header;
      return (
        header.InvoiceSubTotalVentas ??
        header.InvoiceSubTotal ??
        header.InvoiceMontoTotalOperacion ??
        0
      );
    },
    invoiceRentRetention() {
      return (
        this.dataProps.data.header.InvoiceRentaRete ||
        this.dataProps.data.header.InvoiceRetencionRenta ||
        0
      );
    },
    ticketFontScale() {
      return this.normalizeTicketFontSize(this.useNormalTicketV2FontSize) / 7.5;
    },
    clientSummary() {
      const parts = [];
      const name = this.displayText(this.dataProps.data.header.InvoiceName, true);
      const address = this.displayText(
        this.dataProps.data.header.InvoiceAddress,
        true
      );
      const nit = this.displayText(this.dataProps.data.header.InvoiceNIT, false);
      const dui = this.displayText(this.dataProps.data.header.InvoiceDUI, false);

      if (name) parts.push(`CLIENTE: ${name}`);
      if (address) parts.push(address);
      if (nit) parts.push(`NIT: ${nit}`);
      else if (dui) parts.push(`DUI: ${dui}`);

      return parts.join(" / ");
    },
  },
  watch: {
    "dataProps.show"() {},
  },
  methods: {
    isEnabledFlag(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    hasValue(value) {
      return value !== undefined && value !== null && `${value}`.trim() !== "";
    },
    displayText(value, uppercase = false) {
      if (!this.hasValue(value)) return "";
      const text = `${value}`.trim();
      return uppercase ? text.toUpperCase() : text;
    },
    parseNumber(value) {
      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? 0 : parsed;
    },
    normalizeTicketFontSize(value) {
      const parsed = parseFloat(value);
      if (Number.isNaN(parsed)) return 7.5;
      return Math.min(12, Math.max(5, parsed));
    },
    ticketPt(baseValue) {
      return `${(baseValue * this.ticketFontScale).toFixed(2)}pt`;
    },
    ticketLineHeight(baseValue) {
      return (baseValue * this.ticketFontScale).toFixed(2);
    },
    money(value) {
      return this.dataProps.data.header.InvoiceCurrency + this.numberWithCommas(this.parseNumber(value));
    },
    itemSubtotal(item) {
      return (
        this.parseNumber(item.ItemGravada) ||
        this.parseNumber(item.ItemExenta) ||
        this.parseNumber(item.ItemNoSuj) ||
        this.parseNumber(item.ItemNoGravada) ||
        this.parseNumber(item.ItemQuantity) * this.parseNumber(item.ItemUnitPrice)
      );
    },
    itemTaxFlag(item) {
      if (this.parseNumber(item.ItemGravada) > 0) return "G";
      if (this.parseNumber(item.ItemExenta) > 0) return "E";
      if (this.parseNumber(item.ItemNoSuj) > 0) return "N";
      return "";
    },
    showData() {
      if (this.dataProps.show) {
        setTimeout(async () => {
          const partes = this.dataProps.data.header.InvoiceDate.split("/");
          const dia = partes[0];
          const mes = partes[1];
          const anio = partes[2];

          const fechaNueva = `${anio}-${mes}-${dia}`;
          const url =
            this.dataProps.data.branch.AuthFeMode == 1
              ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
              : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

          const opt = {
            errorCorrectionLevel: "H",
            type: "image/png",
            quality: 0.3,
            margin: 1,
            color: {
              dark: "#000000",
              light: "#ffffff",
            },
            width: 100,
          };

          QRCode.toDataURL(url, opt, (error, qrUrl) => {
            if (error) {
              console.log("Error al generar el codigo QR:", error);
              throw error;
            }

            this.urlQr = qrUrl;
          });
          await this.getImages();
        }, 0);
      }
    },
    GetnumberToText(number) {
      if (number) return numberToText(number);
      return "";
    },
    numberWithCommas(x) {
      if (this.keyMaster === "55652726b965155654981d279f4900bf") {
        return formatNumber(x, 4);
      }
      return formatNumber(x);
    },
    async Print() {
      if (this.isEnabledFlag(this.ticketdirectprinting)) {
        this.loading = true;
        await imprimirFactura(this.dataProps.data.header.ID_Invoice, this);
        this.loading = false;
        return true;
      }

      this.loading = true;

      let properties = {};
      let toScale = 0.698;

      if (this.keyMaster == "7fb536861eb4faca5ebe690424ce6371") {
        const pdfWidth = 72.1 * 2.83465;
        const pdfHeight = 210 * 2.83465;
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        };
      } else if (this.keyMaster == "679f296532b2e6338c68854d96282b42") {
        const pdfWidth = 72.1 * 2.83465;
        const pdfHeight = 297 * 2.83465;
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        };
        toScale = 0.675;
      } else if (
        this.keyMaster == "fdea701deefc2f8a21a9dfcd2b5166ca" ||
        this.keyMaster == "fe9f16b15a2d0bc1ad64a56efb4abfda" ||
        this.keyMaster == "579a13b4a79db357b608b247053fc89d" ||
        this.keyMaster == "cc8a8458a6b9a580a055095006d2de66" ||
        this.keyMaster == "e9aaa6a6458a982a4b01c253a76ae58d" ||
        this.keyMaster == "b5df5bc0d3cbf62c52817e7bddc09ff3" ||
        this.keyMaster == "9593c3ca31b86c09c9b764c5baddf846" ||
        this.ticketformat3nstar
      ) {
        const pdfWidth = 76 * 2.83465;
        let pdfHeight = 297 * 2.83465;

        if (this.keyMaster == "579a13b4a79db357b608b247053fc89d") {
          pdfHeight = 400 * 2.83465;
        }

        if (this.keyMaster == "ac7d98c7e5d0db964018ac969140297c") {
          pdfHeight = this.$refs.dataprint.clientHeight * 0.75;
        }

        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        };
        toScale = 0.675;
      } else {
        const pdfWidth = 8 * 28.35;
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, 400],
        };
      }

      const doc = new jsPDF(properties);

      await doc.html(this.$refs.dataprint, {
        callback: function (currentDoc) {
          currentDoc.output();
        },
        x: 0,
        y: 0,
        margin: [0, 0, 0, 0],
        html2canvas: {
          scale: toScale,
          useCORS: true,
          logging: false,
          allowTaint: true,
        },
      });

      doc.autoPrint({ variant: "non-conform" });
      const blob = doc.output("bloburl");
      window.open(blob);

      this.loading = false;
    },

    async Download() {
      this.loading = true;

      let properties = {};
      let toScale = 0.698;

      if (this.keyMaster == "7fb536861eb4faca5ebe690424ce6371") {
        const pdfWidth = 72.1 * 2.83465;
        const pdfHeight = 210 * 2.83465;
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        };
      } else if (this.keyMaster == "679f296532b2e6338c68854d96282b42") {
        const pdfWidth = 72.1 * 2.83465;
        const pdfHeight = 297 * 2.83465;
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        };
        toScale = 0.675;
      } else {
        const pdfWidth = 8 * 28.35;
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, 400],
        };
      }

      const doc = new jsPDF(properties);

      doc.setFont("arial");
      await doc.html(this.$refs.dataprint, {
        callback: function (currentDoc) {
          currentDoc.output();
        },
        x: 0,
        y: 0,
        margin: [0, 0, 0, 0],
        html2canvas: {
          scale: toScale,
          useCORS: true,
          logging: false,
          allowTaint: true,
        },
      });

      doc.save(
        this.dataProps.data.header.ID_Invoice +
          "_" +
          this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
          "_" +
          this.dataProps.data.header.InvoiceName.replaceAll(
            /[:/<>*|/]/g,
            ""
          ).replaceAll('\\"', "") +
          ".pdf"
      );

      this.loading = false;
    },
    async sendMail() {
      try {
        this.mailLabel = null;
        this.mailLabel = "Enviando...";

        let properties = {};
        let toScale = 0.698;

        if (this.keyMaster == "7fb536861eb4faca5ebe690424ce6371") {
          const pdfWidth = 72.1 * 2.83465;
          const pdfHeight = 210 * 2.83465;
          properties = {
            orientation: "p",
            unit: "pt",
            format: [pdfWidth, pdfHeight],
          };
        } else if (this.keyMaster == "679f296532b2e6338c68854d96282b42") {
          const pdfWidth = 72.1 * 2.83465;
          const pdfHeight = 297 * 2.83465;
          properties = {
            orientation: "p",
            unit: "pt",
            format: [pdfWidth, pdfHeight],
          };
          toScale = 0.675;
        } else {
          const pdfWidth = 8 * 28.35;
          properties = {
            orientation: "p",
            unit: "pt",
            format: [pdfWidth, 400],
          };
        }

        const doc = new jsPDF(properties);
        await doc.html(this.$refs.dataprint, {
          callback: function (currentDoc) {
            currentDoc.output();
          },
          x: 0,
          y: 0,
          margin: [0, 0, 0, 0],
          html2canvas: {
            scale: toScale,
            useCORS: true,
            logging: false,
            allowTaint: true,
          },
        });

        this.assignCuerpoDocumento();

        const {
          data: {
            header: { jsonMH },
            dteJson: { ID_Invoice },
          },
        } = this.dataProps;

        const body = {
          dtefilebuffer: new Buffer.from(doc.output("arraybuffer")),
          dtejson: { ...jsonMH, ID_Invoice },
          dtefilebufferfilename:
            this.dataProps.data.header.ID_Invoice +
            "_" +
            this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
            "_" +
            this.dataProps.data.header.InvoiceName.replaceAll(
              /[:/<>*|/]/g,
              ""
            ).replaceAll('\\"', ""),
        };

        this.$API.invoices.sendInvoiceMail(body);

        this.mailLabel = "Se envio el correo correctamente";
        this.$emit("mailSent");
      } catch (error) {
        this.mailLabel = "Ocurrio un error al enviar el correo";
        console.log(error);
      }
    },
    assignCuerpoDocumento() {
      this.dataProps.data.header.jsonMH.cuerpoDocumento =
        this.dataProps.data.body.map((item, index) => ({
          descripcion: item.ItemDescription,
          montoDescu: item.ItemDiscount,
          codigo: item.ID_Item,
          ventaGravada: item.ItemGravada,
          ivaItem: item.ItemIva,
          ventaNoSuj: item.ItemNoSuj,
          ventaExenta: item.ItemExenta,
          numItem: index + 1,
          noGravado: item.ItemNoGravada,
          psv: item.ItemPsv,
          uniMedida: item.ItemMeasureUnit,
          cantidad: item.ItemQuantity,
          precioUni: item.ItemUnitPrice,
        }));
    },
    async downLoadJSON() {
      try {
        const selloRecibido = JSON.parse(
          this.dataProps.data.header.ResponseMhJson
        ).selloRecibido;
        const firmaElectronica =
          this.dataProps.data.header.JsonMhSigned.documento;
        const jsonToSend = {
          ...this.dataProps.data.header.JsonMh.dteJson,
          firmaElectronica,
          selloRecibido,
        };
        delete jsonToSend.passwordPri;

        const aElement = document.createElement("a");
        aElement.setAttribute(
          "download",
          this.dataProps.data.header.ID_Invoice +
            "_" +
            this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
            "_" +
            this.dataProps.data.header.InvoiceName.replaceAll(
              /[:/<>*|/]/g,
              ""
            ).replaceAll('\\"', "") +
            ".pdf"
        );
        this.assignCuerpoDocumento();
        const blob = new Blob([JSON.stringify(jsonToSend)], {
          type: "application/json",
        });
        const href = URL.createObjectURL(blob);
        aElement.href = href;
        aElement.download =
          this.dataProps.data.header.ID_Invoice +
          "_" +
          this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
          "_" +
          this.dataProps.data.header.InvoiceName.replaceAll(
            /[:/<>*|/]/g,
            ""
          ).replaceAll('\\"', "") +
          ".json";
        aElement.click();
        URL.revokeObjectURL(href);
      } catch (error) {
        this.mailLabel = "Ocurrio un error al descargar JSON";
        console.log(error);
      }
    },
    async getImages() {
      const logo = this.dataProps.data.branch.BranchLogoPath;

      if (logo) {
        const LogoBranchBase64 = localStorage.getItem("LogoBranchBase64");

        if (LogoBranchBase64) {
          this.dataProps.data.branch.BranchLogoPath = `${LogoBranchBase64}`;
        } else {
          const { imageBase64: logoImageBase64 } =
            await this.$API.utilities.getImageInBase64({ file: logo });
          this.dataProps.data.branch.BranchLogoPath = `${logoImageBase64}`;
        }
      }
    },
    calculateTotalValues() {
      const invoicePaymentType = this.dataProps.data.header.InvoicePaymentType;
      const invoicePayments = this.dataProps.data.invoicePayments || [];

      if (invoicePaymentType) {
        this.cash = this.dataProps.data.header.InvoiceMontoTotalOperacion;
        this.change = 0;
      }

      if (!invoicePaymentType && invoicePayments.length) {
        invoicePayments.forEach((payment) => {
          if (payment?.DescriptionTypePayment == "Billetes y monedas") {
            this.cash += parseFloat(payment.TotalPayment);
          }

          if (payment?.descriptionPayment == "Billetes y monedas") {
            this.cash += parseFloat(payment.totalPayment);
          }
        });
        this.change = this.dataProps.data.header.MoneyReturn;
        this.cash += this.change;
      }
    },
  },
};
</script>

<style scoped>
.u-row .u-col-100 {
  width: 100% !important;
}

.btnclean {
  border-radius: 15px;
  border: 1px solid white;
  background-color: #f29d35 !important;
  color: white !important;
  margin: 0 6px;
}

.btnclose {
  border-radius: 15px;
  border: 1px solid white;
  background-color: rgb(255, 38, 38) !important;
  color: white !important;
}

.preview-toolbar {
  font-family: Arial, Helvetica, sans-serif !important;
  margin-top: 10px;
  margin-bottom: 10px;
}

.preview-title {
  text-align: center;
  font-size: 30px;
}

.preview-actions {
  text-align: center;
}

.book {
  margin: 0;
  padding: 20px 0;
  background-color: rgb(105, 105, 105);
  font-family: Arial, Helvetica, sans-serif !important;
}

.book-frame {
  margin: 0 auto;
  width: 400px;
  display: flex;
  justify-content: center;
  font-size: 10pt;
}

.ticket-shell {
  margin: 0 !important;
  padding: 0 !important;
  font-family: Arial, Helvetica, sans-serif !important;
}

.ticket {
  width: 325px;
  background: white;
  padding: 18px 22px 32px;
  box-sizing: border-box;
  color: #111;
  font-size: 7.5pt;
  line-height: 1.22;
}

.ticket-alert {
  width: 100%;
  background-color: #d40000;
  color: white;
  text-align: center;
  font-weight: bold;
  padding: 6px 8px;
  margin-bottom: 10px;
}

.ticket-center {
  text-align: center;
}

.ticket-small {
  font-size: 7pt;
}

.ticket-strong {
  font-weight: bold;
}

.ticket-company {
  margin-bottom: 8px;
}

.ticket-company-name {
  font-size: 9pt;
  font-weight: bold;
  margin-bottom: 2px;
}

.ticket-logo-wrap {
  text-align: center;
  margin-bottom: 8px;
}

.ticket-logo {
  max-width: 150px;
  max-height: 58px;
}

.ticket-document-title {
  text-align: center;
  font-size: 10pt;
  font-weight: 800;
  margin: 8px 0 4px;
  text-transform: uppercase;
}

.ticket-meta-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  font-size: 7pt;
  margin: 8px 0 6px;
}

.ticket-qr-wrap {
  text-align: center;
  margin: 8px 0 10px;
}

.ticket-qr {
  width: 125px;
  height: 125px;
}

.ticket-divider {
  border-top: 1px solid #777;
  margin: 8px 0;
}

.ticket-section {
  font-size: 7pt;
}

.ticket-section-title {
  font-size: 8.4pt;
  font-weight: bold;
  margin-bottom: 6px;
}

.ticket-field {
  margin-bottom: 3px;
}

.ticket-label {
  font-weight: bold;
}

.ticket-items-header,
.ticket-items,
.ticket-totals {
  width: 100%;
  border-collapse: collapse;
}

.ticket-items-header th {
  font-size: 7pt;
  text-align: left;
  padding-bottom: 5px;
}

.ticket-items-header th:nth-child(1),
.ticket-items td.qty-cell {
  width: 16%;
}

.ticket-items-header th:nth-child(2),
.ticket-items td.desc-cell {
  width: 46%;
}

.ticket-items-header th:nth-child(3),
.ticket-items-header th:nth-child(4),
.ticket-items td.money-cell {
  width: 19%;
}

.ticket-item-row td {
  vertical-align: top;
  padding: 4px 0;
  border-bottom: 1px dotted #b3b3b3;
}

.ticket-items .qty-cell {
  text-align: left;
  padding-right: 6px;
}

.ticket-items .desc-cell {
  padding-right: 6px;
}

.ticket-items .money-cell {
  text-align: right;
  white-space: nowrap;
}

.item-name {
  font-weight: bold;
  margin-bottom: 2px;
}

.item-subline {
  font-size: 6.6pt;
}

.ticket-totals td {
  padding: 2px 0;
}

.ticket-totals td:last-child {
  text-align: right;
  white-space: nowrap;
}

.ticket-grand-total td {
  padding-top: 8px;
  font-size: 11pt;
  font-weight: 800;
}

.ticket-legend {
  margin-top: 8px;
}

.ticket-customer-footer {
  margin-top: 10px;
  font-size: 7pt;
  font-weight: bold;
}

.ticket-thanks {
  text-align: center;
  font-size: 8pt;
  margin-top: 12px;
}

.ticket-return-note {
  text-align: center;
  font-size: 7pt;
  font-weight: bold;
  margin-top: 8px;
}

.ticket-end-space {
  height: 24px;
}

.preview-toolbar,
.preview-toolbar *,
.book,
.book * {
  font-family: Arial, Helvetica, sans-serif !important;
  letter-spacing: 0.01px;
}
</style>
